// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAPUA0ynp94EjL0VBil4M4NaNieZgCzEeU",
  authDomain: "dia-de-la-vida.firebaseapp.com",
  projectId: "dia-de-la-vida",
  storageBucket: "dia-de-la-vida.firebasestorage.app",
  messagingSenderId: "544555184215",
  appId: "1:544555184215:web:dcc16cf039300c186eb312",
  measurementId: "G-TVFSX0RCH5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export auth and providers
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);